import { supabase } from '@/lib/supabase';

export async function toggleFavorite(songId: number, userId?: string): Promise<boolean> {
  if (!userId) {
    throw new Error('Usuário não identificado');
  }

  try {
    const { data, error } = await supabase
      .rpc('toggle_favorite', { p_song_id: songId });
    
    if (error) {
      throw error;
    }

    // Nota: Logs de favorite são feitos pelos handlers da UI (ex: PlayerPage.handleFavorite)
    // que têm acesso ao contexto completo (section, currentIndex, etc)
    // Este serviço apenas executa a operação no banco e dispara o evento

    // Dispara evento para notificar componentes a refazer a busca
    window.dispatchEvent(new CustomEvent('user-favorites-changed', { 
      detail: { songId, isFavorited: data, userId } 
    }));

    return data;
  } catch (error) {
    console.error('[toggleFavorite] Erro completo:', error);
    throw error;
  }
}

export async function isSongFavorited(songId: number, userId?: string): Promise<boolean> {
  if (!userId) {
    return false;
  }

  try {
    const { data, error } = await supabase
      .rpc('check_song_favorited', { p_song_id: songId });
    
    if (error) {
      return false;
    }
    
    return !!data;
  } catch (error) {
    return false;
  }
}